export const WEB_MAKER_DEFAULT_CONTENT = {
  settings: {
    businessName: "Your Dealership",
    tagline: "Your trusted local dealer",
    phone: "(555) 123-4567",
    email: "info@dealership.com",
    address: "123 Main Street",
    city: "Your City",
    zip: "12345",
    hours: "Mon-Fri: 9AM - 6PM\nSat: 10AM - 4PM",
  },
  sectionData: {
    empty_section: {
      minHeight: 360,
    },
    alert_banner: {
      backgroundColor: "#ffffff",
      message:
        "IMPORTANT: We do NOT take deposits on any vehicle via Cash App or Zelle. Please DO NOT SEND.",
      messageSegments: [
        {
          text: "IMPORTANT: ",
          textStyle: { color: "#cc0000", fontWeight: "bold", fontSize: "14px" },
        },
        {
          text: "We do NOT take deposits on any vehicle via Cash App or Zelle. Please DO NOT SEND.",
          textStyle: { color: "#cc0000", fontWeight: "bold", fontSize: "14px" },
        },
      ],
    },
    hero: {
      headline: "Welcome to Our Dealership",
      subheadline: "Quality vehicles. Trusted service.",
      ctaText: "View Inventory",
      ctaLink: "/inventory",
      ctas: [
        { text: "View Inventory", link: "/inventory" },
      ],
    },
    about: {
      title: "About Us",
      body: "Tell your customers about your dealership, history, and values.",
    },
    services: {
      title: "Services",
      items: [
        { title: "Service 1", description: "Describe this service offering." },
        { title: "Service 2", description: "Describe this service offering." },
        { title: "Service 3", description: "Describe this service offering." },
      ],
    },
    inventory_cta: {
      title: "Browse Our Inventory",
      description: "Find your next vehicle from our current selection.",
      ctaText: "Browse Inventory",
      ctaLink: "/inventory",
    },
    inventory_quick_search: {
      title: "Let's Get Started",
      typeOptions: ["All Types", "Used", "Dealer Certified"],
      makeOptions: [
        "All Makes",
        "BMW",
        "Chevrolet",
        "Ford",
        "Honda",
        "Toyota",
      ],
      yearOptions: ["All Years", "2025", "2024", "2023", "2022", "2021", "2020"],
      ctaText: "View Inventory",
      ctaLink: "/inventory",
      secondaryCtas: [
        { text: "Get Pre-Approved", link: "/contact" },
        { text: "Sell or Trade", link: "/contact" },
      ],
    },
    featured_vehicles: {
      title: "Featured Vehicles",
      inventoryStatusKeys: ["available"],
      vehicleSelection: { mode: "automatic", vehicleKeys: [] },
      limit: 6,
      sortBy: "relevance",
      ctaText: "Full Inventory",
      ctaLink: "/inventory",
    },
    inventory_browser: {
      title: "Cars For Sale",
      showFilters: true,
      viewMode: "grid",
      sortBy: "relevance",
      pageSize: 12,
      contentWidth: 1200,
      minHeight: 560,
    },
    financing_calculator: {
      title: "Estimate Your Payments",
      description:
        "Adjust the estimated credit range, term, down payment, and trade-in value to explore a sample monthly payment.",
      price: 20000,
      primaryCtaLabel: "Get Pre-Approved",
      primaryCtaHref: "/contact?intent=financing",
      initialCreditRange: "650-699",
      initialTermMonths: 60,
      minHeight: 620,
    },
    contact: {
      title: "Contact",
    },
    footer: {
      columns: [
        {
          title: "Shop By Type",
          links: [
            { label: "All Inventory", url: "/inventory" },
            { label: "Cars", url: "/inventory" },
            { label: "Trucks", url: "/inventory" },
            { label: "SUVs", url: "/inventory" },
          ],
        },
        {
          title: "Quick Links",
          links: [
            { label: "View Inventory", url: "/inventory" },
            { label: "Get Pre-Approved", url: "/contact" },
            { label: "Value Your Trade", url: "/contact" },
          ],
        },
        {
          title: "Contact Us",
          showContactDetails: true,
          links: [{ label: "Get Directions", url: "/contact" }],
        },
      ],
    },
  },
  pageData: {
    vehicle_details: {
      saveLabel: "Save",
      printLabel: "Print",
      shareLabel: "Share",
      primaryCtaLabel: "Check Availability",
      availabilityTitle: "Check Availability",
      availabilityDescription: "",
      availabilitySubmitLabel: "Send",
      availabilityDisclaimer: "",
      vehicleInfoTitle: "Vehicle Info",
      equipmentTitle: "Equipment Detail",
    },
  },
};

export const getDefaultCopyrightText = (businessName = WEB_MAKER_DEFAULT_CONTENT.settings.businessName) =>
  `© ${new Date().getFullYear()} ${businessName}. All rights reserved.`;
